import React from "react";

import HomePage from "@pages/Home";
import MidiaPage from "@pages/Midia";
import PlaylistPage from "@pages/Playlist";
import NotFoundPage from "@pages/NotFound";

const routes = [
  {
    path: "/",
    exact: true,
    title: "Home",
    component: () => <HomePage />,
  },
  {
    path: "/midia/:playlist_id/:midia_id",
    exact: true,
    title: "Mídia",
    component: () => <MidiaPage />,
  },
  {
    path: "/playlist/:id",
    exact: true,
    title: "Playlist",
    component: () => <PlaylistPage />,
  },
  {
    path: "*",
    exact: false,
    title: "Page Not Found",
    component: () => <NotFoundPage />,
  },
];

export default routes;
